// Firebase configuration for labqfusion-dev project
// Generated from Firebase CLI: firebase apps:sdkconfig

export const firebaseConfig = {
  apiKey: "AIzaSyDa2qmctJIipMJO0lK7rCFLSW1X5Qb0DX0",
  authDomain: "labqfusion-dev.firebaseapp.com",
  projectId: "labqfusion-dev",
  storageBucket: "labqfusion-dev.firebasestorage.app",
  messagingSenderId: "332021047956",
  appId: "1:332021047956:web:8456a93c6e4bb66dca8a81",
  measurementId: "G-B24SSWC1EV"
}; 